import React from 'react';
import { Play } from 'lucide-react';

interface SharedRunButtonProps {
  onClick: () => void;
  isRunning: boolean;
  visible?: boolean;
}

const SharedRunButton: React.FC<SharedRunButtonProps> = ({
  onClick,
  isRunning,
  visible = true,
}) => {
  if (!visible) return null;

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={isRunning}
      aria-busy={isRunning}
      className="bg-green-600 hover:bg-green-700 text-white font-medium py-2 px-4 rounded-lg inline-flex items-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
    >
      <Play className="w-4 h-4" aria-hidden="true" />
      {isRunning ? 'Running...' : 'Run'}
    </button>
  );
};

export default SharedRunButton;
